<template>
  <div class="confetti-nav-item">
    <div class="nav-item-content">
      <div class="nav-stripe"></div>
      <div v-if="icon" class="nav-icon">
        <ConfettiIcon :icon="icon" />
      </div>
      <div v-else class="nav-icon">
        <slot />
      </div>
      <div class="nav-text">{{ text }}</div>
    </div>
  </div>
</template>

<script>
import ConfettiIcon from "../ConfettiIcon";

export default {
  name: "ConfettiNavItem",
  components: { ConfettiIcon },
  props: {
    icon: {
      type: String,
      default: () => null,
    },
    text: {
      type: String,
      default: () => null,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "confetti/scss/variables/breakpoints";
@import "confetti/scss/variables/colors";
@import "confetti/scss/variables/layout";
@import "confetti/scss/variables/typography";
@import "confetti/scss/layout/navigation-content/mixins";
@import "confetti/scss/layout/navigation-content/confetti-nav-item";

.router-link-active .confetti-nav-item {
  font-weight: $bold;
}
</style>
